module.exports = ElcRuntime.styled5;